import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// maintenance routing
const MaintenanceError404 = Loadable(lazy(() => import('views/pages/maintenance/Error')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const StandaloneRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/pages/404',
      element: <MaintenanceError404 />
    }
  ]
};

export default StandaloneRoutes;
